import * as Sentry from '@sentry/react';

export const logExceptionToSentry = (error: Error, context: Record<string, unknown>) => {
	Sentry.withScope((scope) => {
		scope.setExtras(context);
		Sentry.captureException(error);
	});
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logInfoToSentry = (info: any) => {
	Sentry.withScope(() => {
		Sentry.addBreadcrumb({
			message: 'Info',
			level: 'info',
			category: 'info',

			data: info,
		});
	});
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logErrorToSentry = (error: any) => {
	Sentry.withScope(() => {
		Sentry.addBreadcrumb({
			message: 'An error has been thrown',
			level: 'error',
			category: 'error',

			data: error,
		});
	});
};

export const logBrowserInfoToSentry = () => {
	Sentry.withScope((scope) => {
		scope.setExtra('browser', navigator.userAgent);
		Sentry.captureMessage('Browser info captured');
	});
};

export const logUserDetailsToSentry = (userId: string, email: string) => {
	Sentry.withScope((scope) => {
		scope.setUser({ id: userId, email });
		Sentry.captureMessage('User details captured');
	});
};
